const sectionReviewGrid05Css = `
[data-type='section-review-grid-05'] [data-attribute='card-container'] {
  padding: 40px 0;
  background-color: var(--background-color, #ffffff);
}

[data-type='section-review-grid-05'] [data-attribute='card-container'][data-show-rating='false'] .swiper .wrap-item .wrap-stars {
  display: none !important;
}

[data-type='section-review-grid-05'] .wrap-card-inner {
  max-width: var(--container-width, 75%);
  margin: 0 auto;
  width: 100%;
}

[data-type='section-review-grid-05'] .card-header {
  color: var(--text-color, #000000);
}

[data-type='section-review-grid-05'] .card-header:not(:empty) {
  margin-bottom: 24px !important;
}

[data-type='section-review-grid-05'] .card-header h1,
[data-type='section-review-grid-05'] .card-header h2,
[data-type='section-review-grid-05'] .card-header h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 12px 0 !important;
}

[data-type='section-review-grid-05'] .card-header h1:last-child,
[data-type='section-review-grid-05'] .card-header h2:last-child,
[data-type='section-review-grid-05'] .card-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-review-grid-05'] .card-header p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-review-grid-05'] .card-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-review-grid-05'] .swiper {
  position: relative;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
  margin-top: 16px;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-stars svg {
  fill: #c4c4c4;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: var(--star-color, #14a16c);
  fill: var(--star-color, #14a16c);
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content {
  margin-top: 16px;
  color: var(--text-color, #000000);
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h1,
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h2,
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h3 {
  font-size: 18px;
  line-height: normal;
  margin: 0 0 8px 0 !important;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h1:last-child,
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h2:last-child,
[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content p {
  font-size: 16px;
  margin-bottom: 6px !important;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-content p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item img {
  flex: 1;
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-video {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-video video {
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-video .volume {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000000a1;
  color: white;
  border-radius: 50%;
  cursor: pointer;
}

[data-type='section-review-grid-05'] .swiper .swiper-wrapper .wrap-item .wrap-item-video .volume svg {
  width: 20px;
  height: 20px;
}

[data-type='section-review-grid-05'] .swiper-pagination {
  position: relative;
  margin-top: 20px;
}

[data-type='section-review-grid-05'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-review-grid-05'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

@container (max-width: 768px) {
  [data-type='section-review-grid-05'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-review-grid-05'] .wrap-card-inner {
    max-width: 100%;
  }

  [data-type='section-review-grid-05'] .card-header {
    padding-inline: 16px;
  }

  [data-type='section-review-grid-05'] .card-header h1,
  [data-type='section-review-grid-05'] .card-header h2,
  [data-type='section-review-grid-05'] .card-header h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-review-grid-05'] .card-header p {
    font-size: 14px;
  }
}
`;
export default sectionReviewGrid05Css;
